
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 55 65","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".8","fill-rule":"evenodd","clip-rule":"evenodd","d":"M32.47 0l21.648 21.647v35.718a7.576 7.576 0 01-7.577 7.576H7.576A7.576 7.576 0 010 57.365V7.577A7.576 7.576 0 017.576 0h24.895z","fill":"url(#paint0_linear)"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M54.118 21.647H40.43c-4.185 0-7.96-3.775-7.96-7.96V0l21.648 21.647z","fill":"#fff","fill-opacity":".4"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33.674 27.059H12.026c-.664 0-1.203.538-1.203 1.203v19.242c0 .664.539 1.202 1.203 1.202h21.648c.665 0 1.203-.538 1.203-1.202V28.262c0-.665-.538-1.203-1.203-1.203zm-2.405 18.04H14.432v-6.013l3.608-3.609 6.013 6.014 3.608-3.609 3.608 3.609v3.607zm-4.81-12.027a2.405 2.405 0 104.81 0 2.405 2.405 0 00-4.81 0z","fill":"#fff"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"0","y1":"0","x2":"0","y2":"64.941","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#36D2AD"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#2DBC9A"}})])])])
          )
        }
      }
    